"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const native_1 = require("@react-navigation/native");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const icon_1 = __importDefault(require("../../components/icon/icon"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const styles_1 = __importDefault(require("../../styles/styles"));
const screenConstants_1 = require("../../constants/screenConstants");
const typesConstants_1 = require("../../constants/typesConstants");
const pressable_1 = __importDefault(require("../../components/pressable/pressable"));
const eventConstants_1 = require("../../constants/eventConstants");
const navBar_1 = __importDefault(require("../../components/navBar/navBar"));
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const qualityAssuranceSlice_1 = require("./qualityAssuranceSlice");
const spinner_1 = __importDefault(require("../../components/spinner/spinner"));
const messageComponent_1 = __importDefault(require("../../components/messageComponent/messageComponent"));
const colors_1 = __importDefault(require("../../styles/colors"));
const qualityAssuranceConstants_1 = require("./qualityAssuranceConstants");
const paginatedMessageComponent_1 = __importDefault(require("../../components/messageComponent/paginatedMessageComponent"));
const constants_1 = require("../../constants/constants");
const audioPlayer_1 = __importDefault(require("../../components/audioComponent/audioPlayer"));
const callDetailRecordTable_1 = __importDefault(require("../../components/auditComponent/callDetailRecordTable"));
const boxTitle_1 = __importDefault(require("../../components/boxTitle/boxTitle"));
const filterCallRecord_1 = __importDefault(require("../../components/filterCallRecord/filterCallRecord"));
const QualityAssurance = () => {
    const { callRecords, loadingStatus, auditErrorMessage, selectedCallRecordIndex } = useAppSelector_1.default((state) => ({
        callRecords: state.qualityAssurance.callRecords,
        selectedCallRecordIndex: state.qualityAssurance.selectedCallRecordIndex,
        loadingStatus: state.qualityAssurance.loadingStatus,
        auditErrorMessage: state.qualityAssurance.errorMessage,
    }));
    const route = native_1.useRoute();
    const callRecordId = route.params && route.params.call_record_id;
    const callRecordIdParams = { ...(callRecordId && { id: callRecordId }) };
    const isDesktop = useWebDesktopDesign_1.default(constants_1.DESKTOP_BREAKPOINT_2);
    const dispatch = useAppDispatch_1.default();
    const navigator = native_1.useNavigation();
    const [queryParams, setQueryParams] = react_1.useState({
        ...qualityAssuranceConstants_1.initialFilterParams,
        ...callRecordIdParams,
    });
    const containerStyle = isDesktop ? styles_1.default.allScreenWeb : styles_1.default.allScreenMobile;
    // Check if record url is empty.
    const displayAudioPlayer = !!(callRecords.length > 0 &&
        typeof selectedCallRecordIndex === 'number' &&
        callRecords[selectedCallRecordIndex] &&
        callRecords[selectedCallRecordIndex].record);
    // Get callrecords
    react_1.useEffect(() => {
        dispatch(qualityAssuranceSlice_1.getCallDetailRecords(callRecordIdParams));
    }, []);
    react_1.useEffect(() => {
        // Set record default record
        if (callRecords.length > 0 && typeof selectedCallRecordIndex !== 'number') {
            dispatch(qualityAssuranceSlice_1.setSelectedCallRecordIndex(0));
        }
    }, [callRecords.length]);
    const onRowPress = ({ index }) => {
        dispatch(qualityAssuranceSlice_1.setSelectedCallRecordIndex(index));
    };
    let content = react_1.default.createElement(react_1.default.Fragment, null);
    const onPageChange = (page) => {
        dispatch(qualityAssuranceSlice_1.setSelectedCallRecordIndex(null));
        dispatch(qualityAssuranceSlice_1.resetCallRecordState());
        dispatch(qualityAssuranceSlice_1.getCallDetailRecords({ ...queryParams, page }));
    };
    if (loadingStatus === typesConstants_1.PENDING_STATUS) {
        content = react_1.default.createElement(spinner_1.default, null);
    }
    else if (loadingStatus === typesConstants_1.SUCCEEDED_STATUS || callRecords.length > 0) {
        if (callRecords.length === 0) {
            content = (react_1.default.createElement(paginatedMessageComponent_1.default, { message: "No Call Record Found.", color: colors_1.default.BLUE, icon: free_solid_svg_icons_1.faSadTear }));
        }
        else {
            content = (react_1.default.createElement(react_1.default.Fragment, null,
                displayAudioPlayer && (react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.boxStyles, styles_1.default.flexOne, styles_1.default.blueBackground] },
                        react_1.default.createElement(audioPlayer_1.default, null)))),
                react_1.default.createElement(callDetailRecordTable_1.default, { onPageChange: onPageChange, onRowPress: onRowPress })));
        }
    }
    else {
        content = react_1.default.createElement(messageComponent_1.default, { message: auditErrorMessage, color: colors_1.default.RED, icon: free_solid_svg_icons_1.faExclamationCircle });
    }
    return (react_1.default.createElement(navBar_1.default, null,
        react_1.default.createElement(react_native_1.View, { style: containerStyle },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.marginTen] },
                    react_1.default.createElement(boxTitle_1.default, { title: "Quality Assurance" })),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterEnd, styles_1.default.flexOne] },
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(pressable_1.default, { onPress: () => navigator.navigate(screenConstants_1.DASHBOARD_SCREEN), style: [styles_1.default.flexDirectionRow, styles_1.default.alignCenterCenter], eventName: eventConstants_1.NAVIGATE_HOME_BUTTON },
                            react_1.default.createElement(react_native_1.View, null,
                                react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faArrowLeft })),
                            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
                                react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textColorBlue }, ` Dashboard `)))))),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionColumn },
                react_1.default.createElement(filterCallRecord_1.default, { setQueryParams: setQueryParams, queryParams: queryParams }),
                content))));
};
exports.default = QualityAssurance;
